import React, { useState } from "react";
import { testimonialsData } from "../data/mock";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonialsData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1
    );
  };

  const currentTestimonial = testimonialsData[currentIndex];

  return (
    <section id="testimonios" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Testimonios Reales
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Lo que dicen nuestros <span className="text-green-600">clientes</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Más de 1,000 empresas confían en SAIP para gestionar sus operaciones diarias. 
            Estas son sus experiencias reales.
          </p>
        </div>

        {/* Main Testimonial */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="relative bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-8 lg:p-12 shadow-xl">
            <Quote className="absolute top-8 left-8 text-blue-200" size={48} />
            
            <div className="text-center">
              <div className="flex justify-center mb-6">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-yellow-400 fill-current" size={24} />
                ))}
              </div>
              
              <blockquote className="text-2xl lg:text-3xl font-medium text-gray-800 mb-8 leading-relaxed">
                "{currentTestimonial.text}"
              </blockquote>
              
              <div className="flex items-center justify-center space-x-4">
                <img 
                  src={currentTestimonial.avatar} 
                  alt={currentTestimonial.name}
                  className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg"
                />
                <div className="text-left">
                  <div className="font-bold text-gray-900 text-lg">{currentTestimonial.name}</div>
                  <div className="text-gray-600">{currentTestimonial.position}</div>
                  <div className="text-blue-600 font-semibold">{currentTestimonial.company}</div>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-center items-center space-x-4 mt-8">
              <button 
                onClick={prevTestimonial}
                className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
              >
                <ChevronLeft className="text-gray-600" size={20} />
              </button>
              
              <div className="flex space-x-2">
                {testimonialsData.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-3 h-3 rounded-full transition-all ${
                      index === currentIndex ? 'bg-blue-600 w-8' : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                  />
                ))}
              </div>
              
              <button 
                onClick={nextTestimonial}
                className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
              >
                <ChevronRight className="text-gray-600" size={20} />
              </button>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">1000+</div>
            <div className="text-gray-600">Empresas Activas</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 mb-2">99.8%</div>
            <div className="text-gray-600">Satisfacción Cliente</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-purple-600 mb-2">24/7</div>
            <div className="text-gray-600">Soporte Técnico</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-orange-600 mb-2">4.9★</div>
            <div className="text-gray-600">Calificación Media</div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-gray-900 rounded-2xl p-8 lg:p-12">
          <h3 className="text-3xl font-bold text-white mb-4">
            ¿Listo para unirte a empresas exitosas?
          </h3>
          <p className="text-xl text-gray-300 mb-8">
            Programa una demo personalizada y descubre cómo SAIP puede transformar tu negocio
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold transition-colors">
              Solicitar Demo Gratuita
            </button>
            <button className="border border-gray-600 text-gray-300 hover:text-white hover:border-gray-500 px-8 py-4 rounded-xl font-semibold transition-colors">
              Hablar con un Experto
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;